export const FTU_TYPES = {
    ECOMMERCE_SETUP: {
        SETUP_GUIDE: 'ecommerceSetup|setupGuide',
        QUICK_ACTIONS: 'ecommerceSetup|quickActions',
        SEARCH: 'ecommerceSetup|search',
        LEARN_MORE: 'ecommerceSetup|learnMore',
    },
    SMS_BROADCAST: {
        TIMING: 'smsBroadcast|timing',
        SEND: 'smsBroadcast|send',
    },
    AUTOMATED_SMS: {
        TEMPLATES: 'automatedSms|automationTemplates',
    },
    EMAIL_BROADCAST: {
        UNLAYER: 'emailBroadcast|unlayer',
    },
    CONTACT_INFO_HEADER: {
        MENU: 'contactInfoHeader|menu',
        MENU_ICON: 'contactInfoHeader|menuIcon',
    },
};
